import {
  IData_UserSummary,  
} from '../types/schema/user_summary'

import {
  IRecord_CRMTag,
  IRecord_CRMImport_WithJobsAndUser,
} from '../types/schema/crm'

import {
  hasScope,
  hasRole as upstreamHasRole,
} from './role'

export const hasRole = upstreamHasRole

export const canEditCrmOrgPath = (
  summary: IData_UserSummary,
  orgPath: string,
): boolean => {
  const role = summary.roles['crm:writer']
  if(!role) return false
  return hasScope(
    summary.orgNode.org_path,
    orgPath,
    role.scope,
  )
}